/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { FormattedMessage } from 'react-intl-next';
import { isMessagesKey } from '../../util/type-helpers';
import { messages } from '../i18n';
import { emojiCategoryTitle } from './styles';
/**
 * Test id for wrapper Emoji Picker List div
 */
export var RENDER_EMOJI_PICKER_CATEGORY_HEADING_TESTID = 'render-emoji-picker-categorty-heading';
var EmojiPickerCategoryHeading = function EmojiPickerCategoryHeading(_ref) {
  var id = _ref.id,
    title = _ref.title,
    className = _ref.className;
  return jsx("div", {
    id: id,
    "data-category-id": id
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: className,
    "data-testid": RENDER_EMOJI_PICKER_CATEGORY_HEADING_TESTID,
    role: "rowheader"
  }, jsx("div", {
    css: emojiCategoryTitle
  }, isMessagesKey(title) ? jsx(FormattedMessage, messages[title]) : title));
};
export default EmojiPickerCategoryHeading;